export default __webpack_public_path__ + "static/media/legholdtrap.352cfca3.png";